import { useMemo } from 'react'

import { usePermission } from '@circlefin/permissions/react'
import { SANDBOX_EXPERIENCE } from '@services/permissions'
import { UserRoleGroupType } from '@shared/graphql'
import useTranslation from 'next-translate/useTranslation'

export interface RoleNoteProps {
  /**
   * Current Role ID.
   */
  groupType?: UserRoleGroupType
}

export const RoleNote: React.FC<RoleNoteProps> = ({ groupType }) => {
  const { t } = useTranslation('settings')

  // KYC and Identity verification text not required to invite new admin users in sandbox
  const [, sandbox] = usePermission(SANDBOX_EXPERIENCE)

  const content = useMemo(() => {
    switch (groupType) {
      case UserRoleGroupType.ADMINISTRATOR:
        return sandbox.isAuthorized
          ? t('inviteUser.roleDescription.adminForSandbox')
          : t('inviteUser.roleDescription.admin')

      case UserRoleGroupType.VIEWER:
        return t('inviteUser.roleDescription.viewer')

      case UserRoleGroupType.AGENT:
        return t('inviteUser.roleDescription.agent')
      case UserRoleGroupType.ORGANIZATION:
      case UserRoleGroupType.USER_DEFINED:
      case undefined:
        return null
    }
  }, [groupType, sandbox.isAuthorized, t])

  if (groupType == null) {
    return null
  }

  return <div className="pt-3 text-sm text-black-400">{content}</div>
}
